import { Routes } from '@angular/router';
import { authGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const reportsRoutes: Routes = [
  {
    path: 'reports',
    title: 'Berichte',
    loadComponent: () =>
      import('./reports-overview/reports-overview').then(m => m.ReportsOverviewComponent),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/revenue-accounts',
    title: 'Bericht: Erlöskonten',
    loadComponent: () =>
      import('./revenue-account-report/revenue-account-report').then(
        m => m.RevenueAccountReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/revenue-account-summary',
    title: 'Bericht: Erlöskonten-Zusammenfassung',
    loadComponent: () =>
      import('./revenue-account-summary-report/revenue-account-summary-report').then(
        m => m.RevenueAccountSummaryReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/service-items-revenue',
    title: 'Bericht: Leistungen & Erlöskonten',
    loadComponent: () =>
      import('./service-items-revenue-report/service-items-revenue-report').then(
        m => m.ServiceItemsRevenueReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
  {
    path: 'reports/order-service-items',
    title: 'Bericht: Auftrags- & Leistungsauswertung',
    loadComponent: () =>
      import('./order-service-items-report/order-service-items-report').then(
        m => m.OrderServiceItemsReportComponent
      ),
    canActivate: [authGuard],
    data: { roles: [UserRoles.REPORTS_READ] },
  },
];
